<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('adapters.taobao'), $t('action.authorize')]"
      ></breadcrumb>
      <div class="container">
        <div class="pd20 center">
          <div
            v-if="refUserId != null && refUserId != '' && refUserId != 'null'"
          >
            淘宝店铺ID：{{ refUserId }}
          </div>
          <div
            v-if="
              refUserNick != null && refUserNick != '' && refUserNick != 'null'
            "
          >
            淘宝店铺昵称：{{ refUserNick }}
          </div>
          <div style="margin-top: 50px; font-size: 24px; color: #d1d1d1">
            {{ $t("rules.buttJoint", [$t("adapters.taobao")]) }}
          </div>
        </div>
        <div class="form-footer">
          <el-button
            type="primary"
            size="medium"
            plain
            :loading="saveSubmitDing"
            @click="saveSubmit"
            >{{ $t("action.agreeAuthorize") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import TaobaoStore from "@/api/adapterTaobaoStore";
import Cookies from "@/utils/cookies";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      errorDescription: null,
      refUserId: null,
      refUserNick: null,
      saveSubmitDing: false,
    };
  },
  mounted() {},
  created() {
    // console.log(
    //   Cookies.getRowId(),
    //   "===",
    //   window.location.href,
    //   "+++",
    //   Util.parseQueryString(window.location.href, "code")
    // );

    // https://base.jianyingkeji.com/normal/adapter/taobaos/show?refUserId=2843385664&refUserNick=gillian%E5%90%89%E8%8E%B2%E5%A9%9A%E7%BA%B1%E7%A4%BC%E6%9C%8D&platformType=%E6%B7%98%E5%AE%9D&expiresTime=2023-04-03%2005%3A59%3A59&reExpiresTime=2023-04-03%2005%3A59%3A59
    // this.errorDescription = decodeURIComponent(
    //   Util.parseQueryString(window.location.href, "error_description")
    // );
    this.refUserId = decodeURIComponent(
      Util.parseQueryString(window.location.href, "refUserId")
    );
    this.refUserNick = decodeURIComponent(
      Util.parseQueryString(window.location.href, "refUserNick")
    );
  },

  methods: {
    saveSubmit() {
      const self = this;
      self.saveSubmitDing = false;
      const obj = {
        refUserId: this.refUserId,
        refUserNick: this.refUserNick,
      };
      TaobaoStore.authorize(Cookies.getRowId(), obj).then(function (res) {
        Cookies.removeRowId();
        if (res.status === 200) {
          self.saveSubmitDing = false;
          self.$message({
            message: self.$t("prompt.authorizeSuccess"),
            type: "success",
          });
          self.$router.push({ name: "adapterTaobaos" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>